import { DefaultValues } from 'react-hook-form'
import clone from 'clone-deep'

import { useDrivingLicenceValidator } from '../formManager/drivingLicenceValidator/useDrivingLicenceValidator'
import { State } from '../types'
import { claimFreeDiscountDefaultValues } from 'directFlow/pages/ClaimFreeDiscount/schema'
import { driversPageDefaultValues } from 'directFlow/pages/Drivers/schema/schema'
import { historyDefaultValues } from 'directFlow/pages/History/schema'
import { licencePageDefaultValues } from 'directFlow/pages/Licence/schema/schema'
import { manualVehicleLookupDefaultValues } from 'directFlow/pages/ManualVehicleLookup/schema'
import { policyStartDateDefaultValues } from 'directFlow/pages/PolicyStartDate/schema/schema'
import { previousCancellationDefaultValues } from 'directFlow/pages/PreviousCancellation/schema'
import { previousCancellationYearDefaultValues } from 'directFlow/pages/PreviousCancellationYear/schema'
import { registrationDefaultValues } from 'directFlow/pages/Registration/schema'
import { usagePageDefaultValues } from 'directFlow/pages/Usage/schema/schema'
import { vehiclePageDefaultValues } from 'directFlow/pages/Vehicle/schema'
import { vehicleFoundPageDefaultValues } from 'directFlow/pages/VehicleFound/schema/schema'
import { Page, StepPage } from 'directFlow/types'

const defaultValuesByPage: {
  [page in StepPage]: DefaultValues<State[page]>
} = {
  [Page.REGISTRATION]: registrationDefaultValues,
  [Page.MVL]: manualVehicleLookupDefaultValues,
  [Page.VEHICLE_FOUND]: vehicleFoundPageDefaultValues,
  [Page.VEHICLE]: vehiclePageDefaultValues,
  [Page.DRIVERS]: driversPageDefaultValues,
  [Page.LICENCE]: licencePageDefaultValues,
  [Page.HISTORY]: historyDefaultValues,
  [Page.CLAIM_FREE_DISCOUNT]: claimFreeDiscountDefaultValues,
  [Page.PREVIOUS_CANCELLATION]: previousCancellationDefaultValues,
  [Page.PREVIOUS_CANCELLATION_YEAR]: previousCancellationYearDefaultValues,
  [Page.USAGE]: usagePageDefaultValues,
  [Page.POLICY_START_DATE]: policyStartDateDefaultValues,
} as const

export const getDefaultPageState = <CurrentPage extends StepPage>(
  page: CurrentPage,
): DefaultValues<State[CurrentPage]> => {
  return clone(defaultValuesByPage[page])
}

export type AsyncValidators = {
  drivingLicenceValidator: ReturnType<typeof useDrivingLicenceValidator>
  additionalDriverLicenceValidator: ReturnType<typeof useDrivingLicenceValidator> | undefined
}
